(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tavell-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const page = document.querySelector('.tavell-theme');
    if (!page || page.dataset.tvReady) return;
    page.dataset.tvReady = 'true';
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const wide = matchMedia('(min-width: 1000px)');
    const activeAnimations = new Set();
    const seen = new WeakSet();
    const media = new Set();
    const videoControllers = new Map();
    let frame = 0;
    const editor = Boolean(window.Shopify && Shopify.designMode);
    const motion = () => page.classList.contains('tavell-home') && !reduce.matches && !editor && page.dataset.tvMotion !== 'off';
    const cinematic = () => motion() && wide.matches && page.dataset.tvMotion === 'cinematic';
    const animate = (node, frames, options) => {
      if (!node.animate) return;
      const animation = node.animate(frames, options);
      activeAnimations.add(animation);
      animation.onfinish = animation.oncancel = () => activeAnimations.delete(animation);
    };
    const reveal = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        reveal.unobserve(entry.target);
        if (!motion()) return;
        const index = [...entry.target.parentElement.children].indexOf(entry.target);
        animate(entry.target, [{opacity:.25, transform:'translateY(26px)'}, {opacity:1, transform:'translateY(0)'}], {duration:850, delay:Math.min(index,3)*60, easing:'cubic-bezier(.2,.65,.2,1)'});
      });
    }, {threshold:.06, rootMargin:'0px 0px -24px 0px'}) : null;
    const update = () => {
      frame = 0;
      media.forEach(node => {
        const picture = node.querySelector('picture');
        if (!picture) return;
        if (!cinematic()) {picture.style.transform = '';return;}
        const rect = node.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return;
        const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / innerHeight));
        picture.style.transform = `translateY(${progress * 22}px) scale(1.065)`;
      });
    };
    const schedule = () => {if (!frame) frame = requestAnimationFrame(update);};
    const setupVideo = video => {
      if (videoControllers.has(video)) return;
      const mobile = matchMedia('(max-width: 749px)');
      let visible = false;
      let userPaused = false;
      let systemPause = false;
      let interactedAt = 0;
      const pause = () => {if (!video.paused) {systemPause = true; video.pause();}};
      const play = () => {
        if (visible && !document.hidden && video.dataset.autoplay === 'true' && !reduce.matches && !editor && !userPaused) {
          video.play().catch(() => {video.controls = true;});
        }
      };
      const source = () => {
        const url = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
        if (!url || video.getAttribute('src') === url) return;
        pause(); video.src = url; video.load();
      };
      const interaction = () => {interactedAt = performance.now();};
      const onPause = () => {
        if (!systemPause && performance.now()-interactedAt<2000) userPaused=true;
        systemPause=false;
      };
      const onPlay = () => {userPaused=false;};
      const visibility = () => {document.hidden ? pause() : play();};
      const change = () => {source(); if (reduce.matches) {pause();video.controls=true;} else play();};
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        visible=entries[0].isIntersecting;
        if (visible) {source();play();} else pause();
      }, {threshold:.15}) : null;
      video.addEventListener('pointerdown',interaction);
      video.addEventListener('keydown',interaction);
      video.addEventListener('pause',onPause);
      video.addEventListener('play',onPlay);
      mobile.addEventListener('change',change);
      reduce.addEventListener('change',change);
      document.addEventListener('visibilitychange',visibility);
      if (observer) observer.observe(video); else {visible=true;source();play();}
      if (reduce.matches || editor) video.controls=true;
      videoControllers.set(video, () => {
        pause();observer?.disconnect();
        video.removeEventListener('pointerdown',interaction);video.removeEventListener('keydown',interaction);
        video.removeEventListener('pause',onPause);video.removeEventListener('play',onPlay);
        mobile.removeEventListener('change',change);reduce.removeEventListener('change',change);
        document.removeEventListener('visibilitychange',visibility);
      });
    };
    const scan = root => {
      root.querySelectorAll('.tv-copy-inner,.tvv-copy-inner,.section-header,.shopify-section--faq .section-stack__intro,.blog-post-card,.newsletter-content .prose').forEach(node => {
        if (seen.has(node)) return;
        seen.add(node);reveal?.observe(node);
      });
      root.querySelectorAll('[data-tv-parallax]').forEach(node => media.add(node));
      root.querySelectorAll('[data-tv-video]').forEach(setupVideo);
      schedule();
    };
    const reset = () => {if (!motion()) activeAnimations.forEach(a=>a.cancel());schedule();};
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    reduce.addEventListener('change',reset);
    wide.addEventListener('change',reset);
    document.addEventListener('shopify:section:load',event=>scan(event.target));
    document.addEventListener('shopify:section:unload',event=>{
      media.forEach(node=>{if(event.target.contains(node))media.delete(node);});
      videoControllers.forEach((cleanup,node)=>{if(event.target.contains(node)){cleanup();videoControllers.delete(node);}});
      event.target.querySelectorAll('*').forEach(node=>reveal?.unobserve(node));
    });
    scan(document.getElementById('main'));
    const hero=page.querySelector('.tv-presentation--hero .tv-image img');
    if (hero && motion()) animate(hero,[{transform:'scale(1.07)'},{transform:'scale(1)'}],{duration:1600,easing:'cubic-bezier(.2,.7,.2,1)'});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
  } catch(e) { console.error(e); }
})();

})();
